import { atom } from "recoil";


export const noteExpiryAtom = atom({
    key: 'note-expiry', // unique ID (with respect to other atoms/selectors)
    default: "never",
});
